import React, { useEffect, useState } from 'react';
import logo from '../../../assets/website/images/logo.svg';
import { NavLink, useLocation } from 'react-router-dom';
import { CMS_PAGES_POSITIONS } from '../../../utils/Constants';
import * as commonServices from '../services/website.services';
import { capitalizeFirstLetter } from '../../../utils/commonfunction';

function WebsiteHeader() {

    const location = useLocation();
    const [impMenuData, setImpMenuData] = useState([]);

    useEffect(() => {
        commonServices.menuOptions({ menu_location: CMS_PAGES_POSITIONS.HEADER }).then((response) => {
            let companyMenu = [];
            let linksMenu = [];
            response?.data?.forEach(element => {
                if (element.footer_menu_name === 'company') {
                    companyMenu.push(element);
                } else {
                    linksMenu.push(element);
                }
            });
            setImpMenuData(linksMenu);
        }).catch((error) => {
            console.log("error", error);
        });
    }, []);

    useEffect(()=>{
        const navToggle = document.querySelector('.navbar-toggler');
        if (navToggle && navToggle.getAttribute('aria-expanded') === 'true') {
            navToggle.click();
        }
    },[location]);

    return (
      <header>
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            <a className="navbar-brand" href="/">
              <img src={logo} alt="babe" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon text-white"></span>
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" className="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </button>

            {/* <p
              style={{
                fontSize: "35px",
                color: "white",
                fontWeight: 700,
                textDecoration: "underline",
                margin: "0px 90px"
              }}
            >
              Coming to Boston in early 2026!
            </p> */}

            <div className="collapse navbar-collapse position-relative" id="navbarSupportedContent">
                <div className='header_info'>Coming to Boston in early 2026!</div>
            
              <ul className="navbar-nav ps-lg-5 ms-auto mb-2 mb-lg-0 text-center text-lg-left gap-3">
                <li>
                </li>
                <li className="nav-item">
                  <NavLink className="px-0 nav-link" to="/">
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="px-0 nav-link" to="/about">
                    About
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                                <NavLink className="nav-link" to="/meetTheFounder">Meet the Founders</NavLink>
                            </li> */}
                {/* <li className="nav-item">
                                <NavLink className="px-0 nav-link" to="/boston-pre-launch">Boston Pre-Launch</NavLink>
                            </li> */}
                <li className="nav-item mb-4 mb-lg-0">
                  {/* <a className="nav-link" href="/contact-us">Contact us</a> */}
                  <NavLink className="px-0 nav-link" to="/contact-us">
                    Contact Us
                  </NavLink>
                </li>
                {impMenuData &&
                  impMenuData.length > 0 &&
                  impMenuData.map((item, index) => (
                    <li key={index} className="nav-item">
                      <NavLink className="nav-link" to={`/org-info/${item?.slug}`}>
                        {capitalizeFirstLetter(item?.title)}
                      </NavLink>
                    </li>
                  ))}
              </ul>
              <div className="button-right ms-3">
                <a href="#get-app" className="btn btn-black decoration-none">
                  Get the App
                </a>
              </div>
            </div>
          </div>
        </nav>
      </header>
    );
}

export default WebsiteHeader;
